import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export interface SaveDefaultViewRequest {
  assetDashBoardDefaultView: Array<{
    widgetId: string
    displayname: string
    devices: any[]
  }>
}

export const ZData = z.object({
  asset_id: z.string(),
  graph_name: z.string()
})

export const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZData)
})

export type SaveDefaultViewResponce = z.infer<typeof ZData>
export type SaveDefaultViewResponceAPIData = z.infer<typeof ZApiResponse>

export async function SaveDefaultViewService (
  assetId: string,
  requestParameter: SaveDefaultViewRequest,
  onSuccess: (SaveDefaultViewResponce: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any,
  onReset: () => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/asset/${assetId}/default-view?dashboardLevel=${'Asset'}`
  interceptedAxios
    .put(url, requestParameter, { timeout: 10000 })
    .then((response) => {
      if (response.status === 201) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    }).finally(() => {
      onReset()
    })
}
